<template>
  <div class="order-card border-b-8 border-neutral-100 last:border-b-0">
    <div
      class="px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4"
    >
      <div
        class="flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center"
      >
        <span>
          <span
            class="inline-flex px-2 py-1 text-xs rounded-md mdmax:flex-shrink-0 text-center"
            :style="'backgroundColor: ' + data.status_color + '; color: white;'"
            >{{ data.status_display }}</span
          >
        </span>
        <div>
          <span
            class="text-neutral-700 font-medium mdmax:text-sm block text-xs mb-1"
            >{{ data.created_time_display }}</span
          >
          <span class="text-neutral-500 mdmax:text-sm block text-xs mb-1">
            <span class="text-neutral-700 font-medium">Nomor pesanan:</span>
            {{ data.order_id }}
          </span>
          <p
            class="text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start"
          >
            <span>
              <span class="text-neutral-700 font-medium">AWB Linknau:</span>
              {{ data.awb }}
            </span>
            <template v-if="data.external_awb">
              <span class="mdmax:hidden">|</span>
              <span>
                <span class="text-neutral-700 font-medium">AWB Mitra:</span>
                {{ data.external_awb }}
              </span>
            </template>
          </p>
        </div>
        <div class="flex items-center gap-6" v-if="isMobile">
          <img
            :src="data.delivery_service_logo"
            class="max-h-14"
            v-if="data.delivery_service_logo"
          />
          <LogisticPlaceholder
            :logisticName="data.delivery_service_name"
            v-else
          />
          <span
            class="text-xs text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md"
            v-if="data.delivery_service_name"
            >{{ data.delivery_service_name }}</span
          >
          <!-- <Button buttonText="Lebih Rinci" type="secondary" @action="goToDetail(data.order_id)" v-if="!isMobile" /> -->
        </div>
      </div>

      <span
        v-if="isMobile"
        class="inline-block cursor-pointer"
        @click="expand()"
      >
        <Chevron direction="down" />
      </span>
      <div class="flex items-center gap-6" v-if="!isMobile">
        <img
          :src="data.delivery_service_logo"
          class="max-h-14"
          v-if="data.delivery_service_logo"
        />
        <LogisticPlaceholder
          :logisticName="data.delivery_service_name"
          v-else
        />
        <span
          class="text-xs text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md text-center"
          v-if="data.delivery_service_name"
          >{{ data.delivery_service_name }}</span
        >
        <!-- <Button buttonText="Lebih Rinci" type="secondary" @action="goToDetail(data.order_id)" v-if="!isMobile" /> -->
      </div>
      <div class="flex items-center gap-2">
        <Button
          buttonText="Retry Order"
          size="small"
          type="primary"
          @action="retryShipment()"
        />
        <Button
          buttonText="Batalkan Pesanan"
          size="small"
          type="delete_outline"
          @action="toggleModalCancelOrder()"
        />
      </div>
    </div>

    <div
      class="flex justify-between flex-wrap items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none"
      :class="{ hidden: !visibleContent && isMobile }"
    >
      <div
        class="w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b"
      >
        <!-- <div class="py-2 mb-2" v-if="isMobile">
          <Button buttonText="Lebih Rinci" type="secondary" size="full" @action="goToDetail(data.order_id)" />
        </div> -->
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">
              Nama Pengirim
            </p>
            <p
              class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden"
              :title="data.sender_name"
            >
              {{ data.sender_name }}
            </p>
            <p class="text-neutral-400 text-sm">{{ data.sender_phoneno }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">
              Alamat Pengirim
            </p>
            <p
              class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
            >
              {{ data.pickup_address }}
            </p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
          <p>{{ data.pickup_detail || "-" }}</p>
        </div>
      </div>
      <div
        class="w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b"
      >
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p
              class="text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap"
            >
              Nama Penerima
            </p>
            <p
              class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden"
              :title="data.receiver_name"
            >
              {{ data.receiver_name }}
            </p>
            <p class="text-neutral-400 text-sm">{{ data.receiver_phoneno }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">
              Alamat Penerima
            </p>
            <p
              class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
            >
              {{ data.destination_address }}
            </p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">
            Detail Pengiriman
          </p>
          <p>{{ data.destination_detail || "-" }}</p>
        </div>
      </div>
      <div class="w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b">
        <div class="mb-6">
          <p class="text-sm font-medium mb-1 text-neutral-700">Berat Barang</p>
          <p>{{ data.goods_weight }} kg</p>
        </div>
        <div class="">
          <p class="text-sm font-medium mb-1 text-neutral-700">Jenis Paket</p>
          <p>{{ data.goods_category }}</p>
        </div>
      </div>
      <div class="w-full p-4 border-t mdmax:border-none mdmax:shadow-border-b">
        <p class="text-sm font-medium mb-2 text-neutral-700">Rincian Pembayaran</p>
        <div class="flex flex-wrap gap-x-8 gap-y-2 text-sm">
          <div>
            <p class="text-neutral-500 mb-1">Harga Awal</p>
            <p class="font-medium text-neutral-700">{{ (data.original_price || 0) | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-neutral-500 mb-1">Biaya Asuransi</p>
            <p class="font-medium text-neutral-700">{{ (data.insurance_cost || 0) | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-neutral-500 mb-1">Potongan Voucher</p>
            <p class="font-medium text-system-error">- {{ (data.voucher_amount || 0) | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-neutral-500 mb-1">Diskon</p>
            <p class="font-medium text-system-error">- {{ (data.discount_amount || 0) | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-neutral-700 font-bold mb-1">Total Pembayaran</p>
            <p class="font-bold text-neutral-700">{{ (data.total_price || 0) | currencyFormat }}</p>
          </div>
        </div>
      </div>
    </div>
    <CancelOrderModal
      :modal="visibleModalCancelOrder"
      @toggle="toggleModalCancelOrder()"
      @closeAll="closeAll()"
      :orderId="data.order_id"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import CancelOrderModal from "@/views/Order/CancelOrderModal.vue"
import { currencyFormat } from "@/util"

export default {
  filters: {
    currencyFormat
  },
  components: {
    Button: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/Button"),
    Chevron: () =>
      import(/* webpackChunkName: "Icons" */ "@/components/Icons/Chevron"),
    LogisticPlaceholder: () =>
      import(
        /* webpackChunkName: "LogisticPlaceholder" */ "@/components/Icons/LogisticPlaceholder"
      ),
    CancelOrderModal
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visibleContent: false,
      status: {
        PYMWAI: "text-neutral-500 bg-neutral-300",
        PYMCNF: "text-white bg-system-warning",
        DLVD: "text-white bg-system-success",
        CNC: "text-white bg-system-error",
        HUBPRCD: "text-white bg-system-warning",
        HUBRJCT: "text-white bg-system-error"
      },
      visibleModalCancelOrder: false
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push(`/order/detail/${id}`)
    },
    expand() {
      this.visibleContent = !this.visibleContent
    },
    toggleModalCancelOrder() {
      this.visibleModalCancelOrder = !this.visibleModalCancelOrder
    },
    closeAll() {
      this.visibleModalCancelOrder = false
    },
    async retryShipment() {
      this.$store.dispatch("common/showLoading")
      try {
        await this.$store.dispatch("order/retryShipment", {
          orderId: this.data.order_id
        })
        this.$store.dispatch("common/hideLoading")
        this.$store.dispatch("common/setToast", {
          options: {
            type: "success",
            duration: 3000,
            primaryText: "Berhasil",
            secondaryText: "Request retry create order berhasil dikirim."
          }
        })
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      } catch (err) {
        this.$store.dispatch("common/hideLoading")
        this.$store.dispatch("common/setToast", {
          options: {
            type: "error",
            duration: 3000,
            primaryText: "Gagal",
            secondaryText: err?.response?.data?.message || "Terjadi kesalahan saat retry create order."
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters("common", ["isMobile"]),
    statusClass() {
      return this.status[this.data.status]
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 60px;
  word-break: break-all;
}
</style>
